import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components/typography/typography';

import type { IconTypes } from 'components/icon/icon.types';

import Icon from 'components/icon/icon';

interface InfoItemProps {
  iconName: IconTypes;
  textInfo: string | undefined;
  textClassName?: string;
  iconClassName?: string;
  isLink?: boolean;
  url?: string;
}
const InfoItem: React.FC<InfoItemProps> = (props) => {
  const { iconName, textInfo, textClassName, iconClassName, isLink, url } =
    props;
  const iconeClassNames = twMerge('mr-5 text-purple ', iconClassName);
  const textClassNames = twMerge('text-purple', textClassName);

  return (
    <div className="container mx-0 pl-4 w-full flex flex-row my-2 items-center justify-start text-purple">
      <Icon icon={iconName} className={iconeClassNames} />
      <Typography variant="body-large-bold" as="h3" className={textClassNames}>
        {isLink ? (
          <a href={url} target="_blank" rel="noreferrer">
            {textInfo}
          </a>
        ) : (
          textInfo
        )}
      </Typography>
    </div>
  );
};

export default InfoItem;
